import React,{useRef, useState, useEffect} from "react";
import { Select, Form, Col, Row, Button } from "react-bootstrap";
import EditableRange from "../components/EditableRange";
import atlasApi from "../utils/atlasapi";
import { X, Trash} from "@phosphor-icons/react";
import ColorPicker from "../components/ColorPicker";


class PowerRoadsPanel extends React.Component {

	
	constructor(props) {
		super(props);
		
		
		
		this.range = React.createRef();
		
		this.open = this.props.setup.open;
		this.type = this.props.setup.type;
		this.handler = this.props.handler;
		this.clickedId = -1;
		this.idx = 0;
		this.defaultColor = "#000000"
		this.state = {
			
		};
		
	}
	componentDidMount() {
		if(this.handler)
			this.Type = this.handler.type.charAt(0).toUpperCase() + this.handler.type.slice(1);
	}

	async handleChange(e){
		

	};
	name(){
		
		
		return this.props.setup.obj && this.props.setup.obj.name ? this.props.setup.obj.name : this.makeName();
		
	}
	width(){
		if(this.props.setup.obj)
			return this.props.setup.obj.width ? this.props.setup.obj.width : 10;
		return 10;
	}

	handleWidthChange = (width) => {

		this.width = width;
		
		if(this.props.onWidthChange)
			this.props.onWidthChange(width);
		
		this.forceUpdate();
	};
	
	handleNameChange = (e)=>{
		if(this.props.onNameChange)
			this.props.onNameChange(e.target.value);
	}
	handleColorChange = (color)=>{
		
		if(this.props.onColorChange)
			this.props.onColorChange(color);
		
	}
	handleClose = (e) => {
		if(this.props.onClose)
			this.props.onClose(e);
	}
	handleDelete = (e) => {
		if(this.props.onDelete)
			this.props.onDelete(e);
	}
	handleOnShow(){
		
	}
	handleOnClose(){
		
		this.type = '';
		this.idx = 0;
		
		if(this.props.onClose)
			this.props.onClose();
		this.forceUpdate();
	}
	
	
	componentDidUpdate(prevProps) {
	// Typical usage (don't forget to compare props):
		if (!prevProps.setup.open && this.props.setup.open || (this.props.setup.features && prevProps.setup.features != this.props.setup.features)) {
			this.handleOnShow();
		}
		if (prevProps.setup.open && !this.props.setup.open) {
			this.handleOnClose();
		}
		
	}
	makeName(){
		return this.handler.type+' '+this.handler.parent.scenario.powerlines.length +1;
	}
	
	render() {
		
		

		
		
		
		
		if(!this.props.setup.open){
			return;
		}
		
		return (
			<div className="tools-panel power-roads" >
				<Row>
					<Col xs="12 title pb-2">
						<b>{this.name()}</b>
						<span onClick={this.handleClose} className="btn btn-close btn-sm float-end"><X size={12} /></span>
					</Col>

				
						
					<Col xs="12 mt-4">
						<label>Name</label>
						<Form.Control type="text" name="name" placeholder={"Input "+this.type+" name"} defaultValue={this.props.setup.obj.name} onChange={this.handleNameChange} />
					</Col>
					
					<Col xs="12 my-4">

						<label>{this.type} width(m)</label>
						<EditableRange ref={this.range} wrpClassName="mb-3"  min="0" max="15" step="1" value={this.props.setup.obj.width} onMouseUp={(value)=>{this.handleWidthChange(parseFloat(value));}} />
					</Col>
					{false && this.type == 'Powerline' &&
					<Col xs="12 mt-3">

						<label>{this.Type} color</label>
						<ColorPicker ref={this.fillHue} onChange={this.handleColorChange} color={this.props.setup.obj.color ?? this.defaultColor} />
					</Col>
					}


					<Col xs="8">
						<Button variant="primary" onClick={this.handleClose}>Save & close</Button>
					</Col>
					<Col xs="4 text-end">
						<Button className="ms-auto px-2" variant="outline-primary" onClick={this.handleDelete}><Trash size={16} /></Button>
					</Col>
						
				</Row>
			</div>	
		);
	}
}

export default PowerRoadsPanel;